import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StickyStretchDirective } from "./sticky-stretch.directive";
import { SelectValueOnFocusDirective } from "./select-value-on-focus.directive";

@NgModule({
  declarations: [StickyStretchDirective, SelectValueOnFocusDirective],
  imports: [CommonModule],
  exports: [StickyStretchDirective, SelectValueOnFocusDirective],
})
export class CustomDiretivesModule {}
